import { MainView } from '../components/layout/main'
import Sidebar from '../components/layout/sidebar/sidebar'
import { LenderEditsView } from '../components/views/lenderEditsView'

function LenderEdits() {
    return (
        <div className="lenderEdits">
            <Sidebar />
            <MainView>
                <LenderEditsView />
            </MainView>
        </div>
    )
}

export default LenderEdits
